/* eslint-disable react/no-array-index-key */
import { ReactNode } from 'react';

import { GridFields } from 'components';
import { Stack } from 'libs/ui';
import { type StackProps } from 'libs/ui/Stack/types';

import { Section, SectionProps } from '../Section';

export interface OrderSectionProps extends SectionProps {
  fields: ReactNode[];
  afterFields?: ReactNode;
  spacing?: StackProps['spacing'];
}

export const OrderSection = ({
  afterFields,
  fields,
  spacing = 16,
  ...sectionProps
}: OrderSectionProps) => {
  const content = (
    <Section {...sectionProps}>
      <GridFields>{fields}</GridFields>
    </Section>
  );

  return afterFields ? (
    <Stack spacing={spacing}>
      {content}
      {afterFields}
    </Stack>
  ) : (
    content
  );
};
